import { useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import { bytesToSize } from '../global/helpers';
import ImageCropper from './ImageCropper';

const mimeTypes = ['image/jpg', 'image/png', 'image/jpeg'];

export default ({ name, onChange, handleBlur, inputRef }) => {
    const internalRef = useRef();
    const refInputFile = inputRef ?? internalRef;
    const [cropperOpen, setCropperOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [originalFile, setOriginalFile] = useState(null);

    const handleFile = async (data) => {
        if (!data || !mimeTypes.includes(data.type)) return;

        setOriginalFile(data);
        const imageUrl = URL.createObjectURL(data);
        setSelectedImage(imageUrl);
        setCropperOpen(true);
    };

    const handleCropComplete = ({ base64, preview }) => {
        onChange({
            base64,
            name: originalFile.name,
            size: bytesToSize(originalFile.size),
            preview,
        });
        setCropperOpen(false);
        setSelectedImage(null);
        setOriginalFile(null);
    };

    const handleCropperClose = () => {
        setCropperOpen(false);
        setSelectedImage(null);
        setOriginalFile(null);
        // Limpar o input para permitir selecionar a mesma imagem novamente
        if (refInputFile.current) {
            refInputFile.current.value = '';
        }
    };

    return (
        <>
            <TextField
                inputRef={refInputFile}
                type="file"
                accept="image/jpeg,image/png,image/jpg"
                onChange={e => handleFile(e.target.files[0])}
                onBlur={handleBlur}
                style={{ display: 'none' }}
            />
            <ImageCropper
                open={cropperOpen}
                onClose={handleCropperClose}
                imageSrc={selectedImage}
                onCropComplete={handleCropComplete}
            />
        </>
    );
};